__turbopack_context__.v({
  "border_right": "StatsContainerFaqLp-module-scss-module__ORt7ea__border_right",
  "statics_container": "StatsContainerFaqLp-module-scss-module__ORt7ea__statics_container",
  "stats": "StatsContainerFaqLp-module-scss-module__ORt7ea__stats",
  "text1": "StatsContainerFaqLp-module-scss-module__ORt7ea__text1",
  "text2": "StatsContainerFaqLp-module-scss-module__ORt7ea__text2",
});
